import React from 'react'
import { useLocation } from 'react-router-dom'

import BrowseLibraries from './BrowseLibraries'

const BrowseLibrariesSearchContainer = (): React.ReactNode => {
  const location = useLocation()
  return (
    <BrowseLibraries showInBrowseLibrariesPage={false} location={location} />
  )
}

export default BrowseLibrariesSearchContainer
